import axios from 'axios'
import store from '../vuex/store';
import {
  Message,
  MessageBox
} from 'element-ui'
import Cookies from 'js-cookie'
import Vue from 'vue'
import router from '../router'
import { getLang } from '@/base/cookie'

const service = axios.create({
  baseURL: process.env.BASE_FILE_API,
  timeout: 3600 * 1000 // request timeout
})


service.interceptors.request.use(config => {
  //1：71360用户
  //2：客户端用户
  //3：小程序直接在登录页面登录，账号体系也是客户端用户
  if (Cookies.get('X-Token') && Cookies.get('X-Token') !== undefined) {
    config.headers['X-Token'] = Cookies.get('X-Token')
    config.headers['accept-language']= getLang()
  }

  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})
// respone interceptor
service.interceptors.response.use(
  // response => response.data,
  response => {
    if (response.data && response.data.code === 200) {
      return response.data
    }
    if (response.data && response.data.code === 511) {
      return response.data
    } else {
      if (response.data.code === 401 || response.data.code === 101) {
        router.push('/login')
        store.commit('app/set_login_dialog_isShow',true)
      }
      return Promise.reject(response.data)
    }



  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  })

export default service



// WEBPACK FOOTER //
// ./src/base/request_yun.js